import { graphql, useQuery } from '@/lib/graphql';

const GET_NETWORK_QUERY = graphql(`
  query getTopicTagGraph {
    topicTagGraph {
      nodes {
        id
        label
        description
        value
        weight
        frequency
        isAssist
        isSocialIssue
        nodeType
        themes
        keywords
      }
      edges {
        id
        source
        target
        weight
        label
      }
    }
  }
`);

export const useNetworkData = () => {
  const { data, loading, error } = useQuery(GET_NETWORK_QUERY, {
    errorPolicy: 'all',
  });

  const finalNetwork = {
    nodes: data?.topicTagGraph?.nodes ?? [],
    edges: data?.topicTagGraph?.edges ?? [],
  };

  return {
    network: finalNetwork,
    isLoading: loading,
    error,
  };
};
